define('viewmodels/tournaments/TournamentCampaignsViewModel',['knockout', 'underscore'], function (ko, _) {

    /**
     * @param {Observable<PlayerTournamentCampaign | null>} playerTournamentCampaign
     */
    function TournamentCampaignsViewModel(
        TournamentCampaignViewModel,
        generalPage,
        playerTournamentCampaign,
        tournamentCampaignOverride
    ) {

        var activeTournamentCampaignField = generalPage.findFieldByName('active_tournament_campaign').orElse([]),
            activeTournamentCampaign;

        activeTournamentCampaign = ko.pureComputed(function () {

            var overrideSettings = tournamentCampaignOverride();

            if (overrideSettings && overrideSettings.isEnabled) {
                return overrideSettings.activeTournamentCampaign;
            }

            return activeTournamentCampaignField()[0];

        });

        /**
         * @var {Observable TournamentCampaignViewModel|null}
         */
        this.activeCampaign = ko.pureComputed(function () {
            if (!playerTournamentCampaign()) {
                return null;
            }

            return new TournamentCampaignViewModel(
                generalPage,
                generalPage.getChildBySlug('guns-n-roses'),
                playerTournamentCampaign()
            );

        });

    }

    return TournamentCampaignsViewModel;

});

